/**
 * Text Marquee Slider using Slick
 * Creates a scrolling text marquee effect
 */

(function($) {
    'use strict';

    const TextMarquee = {
        init: function() {
            this.initMarquee();
        },

        initMarquee: function() {
            const $marquee = $('.text-marquee-slider');
            
            if ($marquee.length === 0) return;

            $marquee.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 15000,
                cssEase: 'linear',
                arrows: false,
                dots: false,
                pauseOnHover: false,
                vertical: false,
                swipe: false,
                touchMove: false,
                draggable: false
            });
        }
    };

    // Initialize on document ready
    $(document).ready(function() {
        TextMarquee.init();
    });

})(jQuery);
